import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';

import CommonTooltip from '../../../../../../../../../component/common/CommonTooltip';

const FeatureListTable = (props) => {
    const { features_name, feature_synonyms, index, onDragDrop, } = props;

    const featureSynonyms = feature_synonyms.map((synonym) => (
        <span className="badge badge-light-dark fs-7 fw-bold me-2 text-gray-600" key={uuidv4()}>
            <span className="text-gray-600 fw-bold fs-6">{synonym.value}</span>
        </span>
    ));

    const featureDeleteOnClick = async (index) => {
        const featureDeleteSwal = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won’t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });
        if (featureDeleteSwal.isConfirmed) {
            props.featureDeleteOnClick(index);
        }
    };

    const handleDragStart = (e) => {
        e.dataTransfer.setData('text/plain', index);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const draggedIndex = parseInt(e.dataTransfer.getData('text/plain'), 10);
        onDragDrop(draggedIndex, index);
    };

    return (
        <>
            <tr
                draggable
                onDragStart={handleDragStart}
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDrop}
                style={{
                    cursor: "move",
                }}
            >
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    <div className="text-gray-800 fw-bold mb-1 fs-6">{features_name}</div>
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {featureSynonyms}
                </td>
                <td className="d-flex float-end">
                    <div
                        className="cursor-pointer me-3"
                        onClick={(e) => {
                            e.preventDefault();
                            props.featureUpdateOnClick(index);
                        }}
                        data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Edit"
                    >
                        <FontAwesomeIcon icon={faPen} className="text-primary fs-3" />
                    </div>
                    <div
                        className="cursor-pointer"
                        onClick={(e) => {
                            e.preventDefault();
                            featureDeleteOnClick(index);
                        }}
                        data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Delete"
                    >
                        <FontAwesomeIcon icon={faTrash} className="text-danger fs-3" />
                    </div>
                </td>
            </tr>
            <CommonTooltip
                id="common_tooltip"
                style= {{ backgroundColor: "black", color: "white", fontSize:"14px" }}
                place="top"
                float={true}
            />
        </>
    );
};

const FeatureList = (props) => {
    
    const [featureList, setFeatureList] = useState([]);
    useEffect(() => {
        if (props.featureList) {
            setFeatureList(props.featureList);
        }
    }, [props.featureList]);
    const handleDragDrop = (draggedIndex, targetIndex) => {
        const updatedList = [...featureList];
        const [draggedItem] = updatedList.splice(draggedIndex, 1);
        updatedList.splice(targetIndex, 0, draggedItem);
        updatedList.forEach((item, newIndex) => {
            item.index = newIndex;
        });
        setFeatureList(updatedList);
        props.featuresListOnDrop(updatedList)
    };
    return (
        <>
            {featureList.length > 0 && (
                <>
                    <div className="separator border-gray-300 my-6 mb-0"></div>
                    <div className="col-md-12">
                        <div className="table-responsive">
                            <table className="table table-row-dashed align-middle gs-0 gy-4">
                                <thead>
                                    <tr className="fs-7 fw-bold border-0 text-gray-400">
                                        <th>Feature Name</th>
                                        <th>Feature Synonyms</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {featureList.map((features, i) => (
                                        <FeatureListTable
                                            key={uuidv4()}
                                            features_name={features.feature_name}
                                            feature_synonyms={features.feature_synonyms}
                                            index={i}
                                            featureUpdateOnClick={props.featureUpdateOnClick}
                                            featureDeleteOnClick={props.featureDeleteOnClick}
                                            onDragDrop={handleDragDrop}
                                        />
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default FeatureList;
